import { Icon, Text, HStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import React from 'react';

import { CustomerTableItemTypes } from '..';

export const CustomerAccountStatus: React.FC<CustomerTableItemTypes.ReceiveProps> = ({
  customer,
}) => {
  return (
    <HStack alignItems="center" space={Spacing['stack.quarck']}>
      <Text color={customer.accountStatusTextColorNormalized}>
        {customer.accountStatusNormalized}
      </Text>
      <Icon
        testID="customers-table-item-desktop-account-status-icon"
        size={customer.accountStatusIconSizeNormalized}
        name={customer.accountStatusIconNormalized}
        color={Color[customer.accountStatusIconColorNormalized]}
      />
    </HStack>
  );
};
